import { mockVideos } from "./videos";

export const articleContents: Record<string, string> = {
  "celebrity-secret-date": `<p>近日，有媒体拍到知名男艺人李某与一位神秘女子深夜同回住所的画面，瞬间引爆社交平台。</p>
<p>据目击者透露，当晚约10点左右，李某与该女子在某高档餐厅用餐约两小时。两人在餐厅内举止亲密，多次相视而笑，女子还不时帮李某整理衣领，互动十分自然。</p>
<p>用餐结束后，两人一同步出餐厅。李某戴着口罩和帽子，刻意保持低调，而女子则穿着时尚的黑色连衣裙，手提名牌包包。两人快步走向停靠在路边的保姆车，一同乘车离开。</p>
<p>随后车辆驶入某高档小区，两人先后下车进入同一单元楼，直到次日清晨未见出来的身影。</p>
<p>对此，李某工作室目前尚未作出任何回应。而粉丝们则在评论区炸开了锅，有人祝福道："哥哥终于找到幸福了！"也有人持观望态度："等工作室正式回应再说。"</p>
<p>值得一提的是，李某此前在采访中曾表示自己目前专注事业，暂时没有恋爱计划。这组照片的曝光无疑给他的"单身人设"带来了冲击。</p>
<p>业内人士分析，如果恋情属实，这可能是李某事业的一个重要转折点，毕竟他的粉丝群体以女友粉为主。但也有观点认为，作为演员，恋爱本应是正常的事情，过度关注艺人私生活并不妥当。</p>
<p>记者将继续关注此事的后续发展。</p>`,
  "influencer-live-fail": `<p>拥有千万粉丝的知名带货主播"小甜甜"在昨晚的直播中遭遇了从业以来最尴尬的翻车现场，引发全网热议。</p>
<p>事情发生在昨晚8点的黄金档直播中。当时小甜甜正在推荐一款宣称"一秒提亮肤色"的高端面膜产品。按照流程，她需要现场试用产品并向观众展示效果。</p>
<p>然而就在她将面膜敷上脸的瞬间，直播设备突然出现故障——画面开始卡顿，声音也变得断断续续。小甜甜显然没有意识到问题，继续激情满满地介绍产品，但她的声音传到观众端时已经变成了"电音效果"。</p>
<p>更尴尬的是，当设备恢复后，小甜甜无意中说出了产品的真实进货价——仅为售价的十分之一。尽管她立刻意识到问题并试图圆场，但已经被数十万观众清晰地听到。</p>
<p>弹幕瞬间炸锅，满屏的"666"、"翻车了"刷个不停。小甜甜面色尴尬，试图解释说"刚才说的是另一款产品"，但已经无法挽回局面。</p>
<p>事后，小甜甜发布长文道歉，称自己"一时紧张口误"，并承诺将更加严格要求自己。但评论区仍不乏质疑声，有网友翻出她此前推荐过的多个产品，质疑其带货的真实性。</p>
<p>这一事件也引发了对直播带货行业诚信问题的广泛讨论。有消费者权益保护专家表示，直播带货应当接受更加严格的监管，主播需要对推荐的产品真实性负责。</p>`,
  "cat-opens-door": `<p>一段橘猫独自在家开门的监控视频近日在社交平台走红，累计播放量已突破三百万次，网友纷纷惊叹："这猫成精了！"</p>
<p>视频的拍摄者王女士家住杭州市，养了一只两岁的橘猫名叫"胖虎"。由于工作原因，王女士经常需要出门，但每次回家都发现原本关着的房门被打开了，这让她一度以为自己忘记关门。</p>
<p>直到上周，王女士在家中安装了宠物监控摄像头，才发现真相——原来胖虎已经学会了开门！</p>
<p>监控画面显示，胖虎先是在门前来回踱步，像是在"考察地形"。随后它纵身一跃，两只前爪精准地搭在门把手上，利用自身重量将把手压下来。只听"咔哒"一声，门就开了。</p>
<p>"我当时在办公室看到监控画面，笑得差点从椅子上摔下来。"王女士说，"之前我一直以为是自己忘关门，没想到是这个小家伙搞的鬼。"</p>
<p>这段视频发布后迅速走红，评论区充满了欢乐：</p>
<p>"橘猫的智商你永远不能低估！"</p>
<p>"猫：这个家，我说了算。"</p>
<p>"我家橘猫怎么连猫粮都找不到？"</p>
<p>宠物行为学专家表示，猫咪的学习能力其实很强，特别是与食物和自由相关的行为。橘猫能够学会开门，说明它对环境有很好的观察力和模仿能力，这其实并不罕见。</p>
<p>不过专家也建议，如果猫咪经常开门可能带来安全隐患，可以考虑更换为球形门把手，或者在门上加装儿童安全锁。</p>`,
};

export const detailFallbackContent = `<p>这段视频一经发布便迅速在网络上引发热议，短时间内播放量突破百万。网友们纷纷在评论区发表自己的看法，形成了激烈的讨论。</p>
<p>有网友表示："这种事情真的让人难以置信，现在的社会怎么变成这样了？"</p>
<p>也有网友持不同意见："我觉得大家应该冷静看待，毕竟我们看到的只是片段，不了解全部真相。"</p>
<p>对此，相关方面尚未作出正式回应。本平台将持续关注事件的后续发展。</p>
<p>值得注意的是，类似事件在近期并非首次发生。就在上个月，某地也曾发生过一起引发广泛关注的事件。这两起事件之间是否存在某种联系，目前还是一个未知数。</p>
<p>法律界人士指出，如果相关情况属实，涉事方可能面临严重的法律后果。他表示："根据现行法律规定，此类行为已经构成违法，相关责任方应当承担相应的法律责任。"</p>
<p>社会学者则从另一个角度分析道："这种现象反映出当前社会中存在的一些深层次问题。我们需要从制度层面进行反思和完善。"</p>
<p>作为普通观众，我们也要保持理性，不盲目跟风，不传播未经证实的信息。</p>`;

export const aboutInfo = {
  brandName: "91吃瓜",
  brandIntro: "91吃瓜成立于2020年，是国内领先的吃瓜视频内容平台之一。我们致力于为用户提供最新、最快、最全的吃瓜资讯和高清视频内容，涵盖娱乐圈、社会热点、情感八卦、搞笑趣闻等多个领域。",
  mission: "让每一个热爱吃瓜的人都能在这里找到最精彩的内容，是我们的使命。",
  stats: [
    { label: "日活跃用户", value: "500万+" },
    { label: "日均视频播放量", value: "3000万+" },
    { label: "合作媒体", value: "200+" },
    { label: "内容覆盖领域", value: "30+" },
  ],
  values: [
    { title: "真实可靠", description: "坚持内容真实性核验，为用户提供可信赖的吃瓜资讯。每条视频发布前都经过多重审核。" },
    { title: "快速及时", description: "24小时不间断内容更新，确保用户第一时间获取最新热点资讯和视频内容。" },
    { title: "内容丰富", description: "涵盖多个垂直领域，满足不同用户的多元化观看需求，总有你想看的内容。" },
    { title: "用户体验", description: "持续优化产品体验，提供流畅的高清视频播放服务和便捷的内容浏览功能。" },
  ],
  timeline: [
    { year: "2020", event: "91吃瓜正式上线，首批内容覆盖娱乐圈和社会热点两大板块" },
    { year: "2021", event: "用户突破100万，新增情感八卦、搞笑趣闻内容板块" },
    { year: "2022", event: "推出移动端应用，日活跃用户突破200万" },
    { year: "2023", event: "与多家主流媒体建立内容合作，视频内容库突破10万条" },
    { year: "2024", event: "平台全面升级，引入智能推荐算法，用户体验大幅提升" },
    { year: "2025", event: "日活跃用户突破500万，成为国内领先的吃瓜视频平台" },
    { year: "2026", event: "持续创新，推出个性化定制内容和社区互动功能" },
  ],
  faqs: [
    { question: "91吃瓜是免费的吗？", answer: "是的，91吃瓜平台上的所有视频内容均免费观看，无需付费订阅。我们致力于为用户提供优质的免费吃瓜内容体验。" },
    { question: "如何向我们提供新闻线索？", answer: "您可以通过'关于我们'页面底部的联系方式，或发送邮件至我们的官方邮箱提供新闻线索。我们重视每一条用户提供的信息。" },
    { question: "平台上的内容是否真实可靠？", answer: "我们高度重视内容的真实性，所有发布的视频内容都经过编辑团队的审核验证。对于未经证实的信息，我们会在内容中明确标注。" },
    { question: "可以在手机上观看视频吗？", answer: "当然可以！91吃瓜网站完美适配手机浏览器，您可以在任何移动设备上流畅观看高清视频内容。" },
    { question: "视频加载很慢怎么办？", answer: "建议检查您的网络连接是否稳定。如果网络正常但仍加载缓慢，可以尝试刷新页面或切换到较低清晰度观看。" },
  ],
  contact: {
    email: "contact@91chigua.com",
    phone: "400-888-9191",
    address: "北京市朝阳区建国路88号SOHO现代城A座1508室",
    wechat: "91chigua_official",
  },
};